// Параметры экономики, которые владелец меняет в админке без выкладки (Economy v0.1, п. 73).
// Значения по умолчанию — на сервере (config/ТЗ); здесь — список, названия и допустимые границы.

export const ECONOMY_SETTINGS = [
  { key: 'ticketPrice', group: 'Билеты', label: 'Цена билета, 🪙', min: 1, max: 1_000_000 },
  { key: 'freeTicketsPerDay', group: 'Билеты', label: 'Бесплатных билетов в сутки', min: 0, max: 20 },
  { key: 'silverPerTap', group: 'Тренировка', label: 'Серебра за нажатие', min: 1, max: 100 },
  { key: 'energyMax', group: 'Тренировка', label: 'Энергия, максимум', min: 10, max: 100_000 },
  { key: 'energyRegenSeconds', group: 'Тренировка', label: '+1 энергия раз в N секунд', min: 1, max: 86_400 },
  {
    key: 'trainingDailyCap',
    group: 'Тренировка',
    label: 'Предел тренировки в сутки, 🪙',
    min: 0,
    max: 10_000_000,
  },
  { key: 'maxTapsPerSec', group: 'Тренировка', label: 'Не больше нажатий в секунду', min: 1, max: 30 },
  { key: 't4SemiLoss', group: 'Турнир на 4', label: 'Выбыл в полуфинале, 🪙', min: 0, max: 1_000_000 },
  { key: 't4FinalLoss', group: 'Турнир на 4', label: 'Проиграл финал, 🪙', min: 0, max: 1_000_000 },
  { key: 't4Champion', group: 'Турнир на 4', label: 'Чемпион, 🪙', min: 0, max: 1_000_000 },
  { key: 't4ChampionGold', group: 'Турнир на 4', label: 'Чемпион, 🟡', min: 0, max: 100 },
  { key: 't8QfLoss', group: 'Турнир на 8', label: 'Выбыл в 1/4, 🪙', min: 0, max: 1_000_000 },
  { key: 't8SfLoss', group: 'Турнир на 8', label: 'Выбыл в 1/2, 🪙', min: 0, max: 1_000_000 },
  { key: 't8FinalLoss', group: 'Турнир на 8', label: 'Проиграл финал, 🪙', min: 0, max: 1_000_000 },
  { key: 't8Champion', group: 'Турнир на 8', label: 'Чемпион, 🪙', min: 0, max: 1_000_000 },
  { key: 't8ChampionGold', group: 'Турнир на 8', label: 'Чемпион, 🟡', min: 0, max: 100 },
  { key: 'quickWin', group: '1 на 1', label: 'Победа, 🪙', min: 0, max: 100_000 },
  { key: 'quickLoss', group: '1 на 1', label: 'Поражение, 🪙', min: 0, max: 100_000 },
  { key: 'quickRewardedPerDay', group: '1 на 1', label: 'Оплачиваемых матчей в сутки', min: 0, max: 1000 },
  { key: 'silverGoldRate', group: 'Gold', label: 'Серебра за 1 🟡 (обмен)', min: 1, max: 10_000_000 },
  { key: 'goldExchangePerDay', group: 'Gold', label: 'Обменов 🟡 в сутки', min: 0, max: 100 },
  {
    key: 'claimMinAccountAgeDays',
    group: 'Вывод токена',
    label: 'Дней в игре, не меньше',
    min: 0,
    max: 3650,
  },
  { key: 'claimMinActiveDays', group: 'Вывод токена', label: 'Активных дней в сезоне', min: 0, max: 365 },
  {
    key: 'claimMinRealMatches',
    group: 'Вывод токена',
    label: 'Матчей с живыми соперниками',
    min: 0,
    max: 100_000,
  },
  {
    key: 'minTokenClaimGold',
    group: 'Вывод токена',
    label: 'Вложено 🟡 в сезон, не меньше',
    min: 0,
    max: 1_000_000,
  },
  {
    key: 'walletChangeCooldownDays',
    group: 'Вывод токена',
    label: 'Дней после смены кошелька',
    min: 0,
    max: 365,
  },
  {
    key: 'alertSpikePct',
    group: 'Оповещения',
    label: 'Рост серебра/Gold за сутки к среднему, %',
    min: 110,
    max: 10_000,
  },
  {
    key: 'alertSilverMinDay',
    group: 'Оповещения',
    label: 'Не тревожить, если серебра за сутки меньше',
    min: 0,
    max: 100_000_000,
  },
  {
    key: 'alertTapsPerUserDay',
    group: 'Оповещения',
    label: 'Нажатий у игрока за сутки, больше — тревога',
    min: 100,
    max: 1_000_000,
  },
  {
    key: 'alertTopGoldSharePct',
    group: 'Оповещения',
    label: 'Доля Gold у топ-1 %, больше — тревога, %',
    min: 1,
    max: 100,
  },
  {
    key: 'alertPairMatchesDay',
    group: 'Оповещения',
    label: 'Матчей одной пары за сутки, больше — тревога',
    min: 2,
    max: 1000,
  },
] as const;

export type EconomySettingKey = (typeof ECONOMY_SETTINGS)[number]['key'];
export type EconomySettings = Record<EconomySettingKey, number>;

/** GET /api/admin/economy — параметр, его значение, умолчание и кто менял */
export interface AdminEconomySettingDto {
  key: EconomySettingKey;
  group: string;
  label: string;
  min: number;
  max: number;
  value: number;
  default: number;
  updatedAt: string | null;
}

/** Серебро за место в публичном турнире: eliminatedIn — раунд выбывания, null у чемпиона. */
export function placeRewardFrom(s: EconomySettings, size: number, eliminatedIn: number | null): number {
  if (size === 4)
    return eliminatedIn === null ? s.t4Champion : eliminatedIn === 1 ? s.t4SemiLoss : s.t4FinalLoss;
  if (size === 8)
    return eliminatedIn === null
      ? s.t8Champion
      : eliminatedIn === 1
        ? s.t8QfLoss
        : eliminatedIn === 2
          ? s.t8SfLoss
          : s.t8FinalLoss;
  return 0;
}

export const championGoldFrom = (s: EconomySettings, size: number): number =>
  size === 4 ? s.t4ChampionGold : size === 8 ? s.t8ChampionGold : 0;
